export type PublicArtistRole = 'producer' | 'rapper' | 'producer_rapper';

export interface PublicArtist {
  username: string;
  role: PublicArtistRole;
  state: string | null;
}

export function formatPublicArtistRole(role: PublicArtistRole | string): string {
  if (role === 'producer_rapper') return 'Producer & Rapper';
  if (role === 'producer') return 'Producer';
  if (role === 'rapper') return 'Rapper';
  return role;
}
